// Conversions reference: https://www.rapidtables.com/convert/length/mm-to-feet.html
export const types = {
  LENGTH: "length",
  WEIGHT: "weight",
  VOLUME: "volume"
};

/**
 * @param {*} type choose one of the 3 depending on the data [length, weight, volume]
 * @param {*} data the measure that you want to convert to imperial
 */
function metricToImperial(type, data) {
  if (!type || !data) return;

  if (type === types.LENGTH) {
    if (data < 300) {
      // smaller than 1-foot
      return `${inches.toFixed(1)}in"`;
    }
    const inches = data / 25.4; // converting milimeters to inches
    const feet = Math.floor(inches / 12);

    return `${feet}ft ${(inches - 12 * feet).toFixed(1)}in`;
  }

  if (type === types.WEIGHT) {
    if (data < 454) {
      // less than 1 pound
      const ounces = data / 28.34952;
      return `${ounces.toFixed(1)}oz`;
    }
    const ounces = data / 28.34952;

    const lbs = Math.floor(data / 453.59237);

    return `${lbs}lbs ${(ounces - 16 * lbs).toFixed(1)}oz`;
  }

  if (type === types.VOLUME) {
    return "imperial_volume";
  }
}

/**
 * @param {*} type choose one of the 3 depending on the data [length, weight, volume]
 * @param {*} data the measure that you want to convert to imperial
 */
export function formatMeasurement(type, system, data) {
  if (!type || !data) return;

  if (type === types.LENGTH) {
    if (system === "imperial") {
      return metricToImperial(type, data);
    }

    if (data < 10000) {
      // convert millimeters to centimeters when measurement smaller than 10 meters.
      return `${Math.floor(data / 10)} cm`;
    }

    return `${Math.floor(data / 100)} m`;
  }

  if (type === types.WEIGHT) {
    if (system === "imperial") {
      return metricToImperial(type, data);
    }

    if (data < 1000) {
      return `${data} gr`;
    }
    return `${(data / 1000).toFixed(1)} Kg`;
  }

  if (type === types.VOLUME) {
    if (data < 1000) {
      return `${data} mL`;
    }
    return `${(data / 1000).toFixed(2)} L`;
  }
  return null;
}
